import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useUserOrganization } from '@/hooks/useUserOrganization'

export interface Employee {
  employee_id: number
  full_name: string
}

export function useEmployees() {
  const { data: membership } = useUserOrganization()
  const orgId = membership?.organization_id

  return useQuery({
    queryKey: ['employees', orgId],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('core')
        .from('employees')
        .select('employee_id, full_name')
        .eq('organization_id', orgId!)
        .is('deleted_at', null)
        .order('full_name')

      if (error) throw error
      return (data || []) as Employee[]
    },
    enabled: !!orgId,
    staleTime: 5 * 60_000,
  })
}
